import { MakeupStatus } from "@/openapi/generated";

export const MAKEUP_STATUS_FILTER_ALL = "__all__";

export function makeupStatusFilterOptions(options?: {
  changeRequestedLabel?: string;
}) {
  const changeRequestedLabel =
    options?.changeRequestedLabel ?? "Change proposed";

  return [
    { value: MAKEUP_STATUS_FILTER_ALL, label: "All statuses" },
    { value: MakeupStatus.Pending, label: "Pending approval" },
    { value: MakeupStatus.ChangeRequested, label: changeRequestedLabel },
    { value: MakeupStatus.Approved, label: "Approved" },
    { value: MakeupStatus.Rejected, label: "Rejected" },
    { value: MakeupStatus.Cancelled, label: "Cancelled" },
  ];
}
